<template>
  <transition name="fade" mode="out-in">
    <div class="buy">
      <div class="buy-topBar">
        <span class="btn-back iconfont" @click.stop="showBack">&#xe61c;</span>
        <span class="title">双色球投注</span>
      </div>
      <div class="buy-content">
        <div class="top">
          <div class="btn addSelf" @click.stop="addSelf">
            <span class="iconfont">&#xe64a;</span>
            <span class="btn-text">自选号码</span>
          </div>
          <div class="btn addChoice" @click.stop="choice()">
            <span class="iconfont">&#xe64a;</span>
            <span class="btn-text">机选1注</span>
          </div>
          <div class="btn clear" @click.stop="showClear">
            <span class="btn-text">清空列表</span>
          </div>
        </div>
        <div class="top-pic">
          <span class="pic-left"><img src="../images/cpBarLeft.png"></span>
          <span class="pic-center"><img src="../images/cpBarCenter.png"></span>
          <span class="pic-right"><img src="../images/cpBarRight.png"></span>
        </div>
        <div class="cp-wrap" ref="cp">
          <div class="cp-content">
            <div class="cp-item" v-for="item in processList" :key="item.index"
                 @click.stop="toggleCp(item.index,$event)">
              <div class="btn-wrap" @click.stop="remove(item.index,$event)">
                <span class="btn-remove iconfont">&#xe634;</span>
              </div>
              <div class="info">
                <p class="code">
                  <span><i class="red">{{item.redCode}}</i><i class="blueColor">{{item.blueCode}}</i></span>
                </p>
                <p class="count">
                  <span>{{item.type}}</span>
                  <span>{{item.count}}注</span>
                  <span>{{item.money}}元</span>
                </p>
              </div>
              <div class="icon-right">
                <span class="iconfont">&#xe641;</span>
              </div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="buy-bottomBar">
        <div class="input-box">
          <div class="input-content input-left">
            <span class="label">连续买</span>
            <span class="input-wrap"><input type="number" v-model="periods"></span>
            <span class="label">期</span>
          </div>
          <div class="input-content input-right">
            <span class="label">投</span>
            <span class="input-wrap"><input type="number" v-model="multiple"></span>
            <span class="label">倍</span>
          </div>
        </div>
        <div class="content">
          <p class="total-price">共{{totalMoney}}元</p>
          <p class="total-count">{{totalCount}}注{{multiple}}倍{{periods}}期</p>
          <span class="btn-buy" @click.stop="buy()">付款</span>
        </div>
      </div>
      <toolselect @sure="clear" titleText="清空" text="您确定要清空当前的投注内容?" ref="clearTool"></toolselect>
      <toolselect @sure="back" @cancel="backClear" btn-cancel="清除" btn-sure="保持" titleText="退出" text="是否清除本次选号?"
                  ref="backTool"></toolselect>
      <toolselect @sure="hideBuy()" @cancel="hideBuy()" btn-cancel="了解" btn-sure="知道了" titleText="上传服务器" :text="resText"
                  ref="resTool"></toolselect>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  import BScroll from 'better-scroll';
  import toolselect from 'components/toolselect/toolselect';
  export default{
    props: {
      lotteryList: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        periods: 1,
        multiple: 1,
        resText: ''
      };
    },
    mounted() {
      this.$nextTick(() => {
        this._initScroll();
      });
    },
    computed: {
      processList() {
        let list = [];
        let res = {};
        let type = '';
        let redCode = '';
        let blueCode = '';
        let lotteryList = this.lotteryList;
        for (let i in lotteryList) {
          if (lotteryList[i].type === 'pt') {
            redCode = lotteryList[i].result['redNums'].join(' ');
            blueCode = lotteryList[i].result['blueNums'].join(' ');
            type = (lotteryList[i].count > 1) ? '复式' : '单式';
          }
          if (lotteryList[i].type === 'dt') {
            redCode = '(' + lotteryList[i].result['redNums1'].join(' ') + ') ' + lotteryList[i].result['redNums2'].join(' ');
            blueCode = lotteryList[i].result['blueNums'].join(' ');
            type = '胆拖';
          }
          res = {
            redCode: redCode,
            blueCode: blueCode,
            type: type,
            count: lotteryList[i].count,
            money: lotteryList[i].money,
            index: lotteryList[i].index
          };
          list.push(res);
        }
        list.reverse();
        return list;
      },
      totalMoney() {
        let money = 0;
        let lotteryList = this.lotteryList;
        for (let i in lotteryList) {
          money += parseInt(lotteryList[i].money);
        }
        return money * this.periods * this.multiple;
      },
      totalCount() {
        let count = 0;
        let lotteryList = this.lotteryList;
        for (let i in lotteryList) {
          count += parseInt(lotteryList[i].count);
        }
        return count;
      }
    },
    methods: {
      buy() {
        let res = {list: this.lotteryList};
        this.resText = JSON.stringify(res);
        this.$nextTick(() => {
          this.$refs['resTool'].show();
        });
      },
      hideBuy() {
        this.$refs['resTool'].hide();
      },
      addSelf() {
        this.$emit('hide');
      },
      choice() {
        this.$emit('choice', 1);
      },
      clear() {
        this.$emit('clear');
      },
      showClear() {
        this.$refs['clearTool'].show();
      },
      back() {
        this.$router.push('/');
      },
      showBack() {
        this.$refs['backTool'].show();
      },
      backClear() {
        this.clear();
        this.$nextTick(() => {
          this.$router.push('/');
        });
      },
      remove(index, event) {
        if (!event._constructed) {
          return;
        }
        this.$emit('remove', index);
      },
      toggleCp(index, event) {
        if (!event._constructed) {
          return;
        }
        this.$emit('hide');
        this.$emit('toggle', index);
      },
      _initScroll() {
        if (!this.buyScroll) {
          this.buyScroll = new BScroll(this.$refs['cp'], {
            click: true,
            bounce: false
          });
        } else {
          this.buyScroll.refresh();
        }
      }
    },
    components: {
      toolselect
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .buy
    position:fixed
    z-index:100
    top:0
    left:0
    right:0
    bottom:0
    width:100%
    overflow:hidden
    background-color:#f5f6ed
    &.fade-enter-active, &.fade-leave-active
      transition:all 0.2s linear
    &.fade-enter, &.fade-leave-active
      transform:scale(1, 0)
    .buy-topBar
      width:100%
      height:40px
      color:#fff
      background-color:#d91d36
      .btn-back
        padding:0 10px
        font-weight:600
        font-size:16px
        line-height:40px
      .title
        font-size:17px
        font-weight:600
        line-height:40px
        letter-spacing:2px
    .buy-content
      width:100%
      .top
        display:flex
        justify-content:space-between
        padding:10px 2%
        .btn
          width:30%
          height:35px
          text-align:center
          color:#928268
          background-repeat:no-repeat
          background-size:100% 100%
          background-image:url("../images/cpBtn.png")
          .iconfont
            display:inline-block
            margin-top:11px
            margin-right:4px
            font-size:10px
          .btn-text
            font-size:14px
            line-height:35px
            vertical-align:top
      .top-pic
        display:flex
        margin:0 auto
        width:95.48%
        .pic-left, .pic-right
          display:block
          width:5%
          img
            width:100%
            height:20px
        .pic-center
          display:block
          width:90%
          img
            width:100%
            height:20px
      .cp-wrap
        position:fixed
        z-index:101
        top:115px
        left:0
        right:0
        bottom:101px
        width:100%
        overflow:hidden
        .cp-content
          margin:0 auto
          width:85.48%
          background-color:#fff
          .cp-item
            display:flex
            position:relative
            padding:10px 15px 20px
            .btn-wrap
              display:flex
              justify-content:center
              align-items:center
              margin-right:5%
              .btn-remove
                font-size:18px
                color:#e1dbcb
            .info
              .code
                margin:0
                font-size:14px
                font-weight:600
                line-height:16px
                .red
                  vertical-align:top
                  color:#d91d36
                .blueColor
                  margin-left:8px
                  vertical-align:top
                  color:#5590cc
              .count
                margin:0
                font-size:0px
                height:24px
                span
                  font-size:14px
                  line-height:32px
                  color:#b88f59
                  margin-right:5px
            .icon-right
              flex:1
              display:flex
              justify-content:flex-end
              align-items:center
              span
                font-size:18px
                color:#e1dbcb
            .line
              position:absolute
              bottom:0
              left:0
              width:100%
              height:6px
              background-repeat:repeat-x;
              background-image:url('../images/cpDogBg.png')
            &:last-child
              .line
                background-image:url('../images/cpDot2Bg.png')
    .buy-bottomBar
      position:fixed
      z-index:102
      bottom:0
      left:0
      width:100%
      .input-box
        display:flex
        width:100%
        height:50px
        background-color:#fff
        border-top:1px solid #cdcdcd
        .input-content
          width:50%
          text-align:center
          .label
            display:inline-block
            font-size:16px
            line-height:50px
            color:#938268
            vertical-align:top
          .input-wrap
            display:inline-block
            font-size:16px
            line-height:50px
            color:#938268
            vertical-align:top
            input
              margin-top:10px
              width:50px
              height:30px
              font-size:16px
              line-height:30px
              color:#938268
              text-align:center
              border:1px solid #d1d2d7;
        .input-left
          border-right:1px solid #cdcdcd
      .content
        position:relative
        width:100%
        height:50px
        color:#fff
        background-color:#000
        text-align:center
        .total-price
          margin:0
          font-size:16px
          line-height:24px
          color:#b99b55
          letter-spacing:3px
        .total-count
          margin:0
          font-size:14px
          line-height:24px
          letter-spacing:3px
        .btn-buy
          display:block
          position:absolute
          top:8px
          right:10px
          padding:8px 13px
          font-size:18px
          color:#520d08
          background:-webkit-gradient(linear, 0 0%, 0 100%, from(#fccd01), to(#ff8d08))
</style>



// WEBPACK FOOTER //
// buy.vue?432b9d9a